import NavigationToggle from './navigation-intl-toggle';

const $navigationToggle = document.getElementById('navigation-intl-toggle-button');
const $navigation = document.getElementById('navigation-intl');

if ($navigationToggle) {
  const navigationToggle = new NavigationToggle($navigationToggle);

  // Listener
  navigationToggle.init();
}

if ($navigation) {
  $navigation.classList.add('js-navigation-intl-initialized');
}
